<template>
  <div class="tabBar">
    <router-link class="tab-item" tag="button" v-for="(link, index) in tabs" :key="'tab' + index" :to="link.path">
      <i class="icon ignore" :class="'icon-' + link.icon"></i><span class="f-s13">{{link.title}}</span>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "tab-bar",
    props: {
      tabs: {
        type: Array,
        default () {
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .tabBar{
    width: 100vw;
    position: fixed;
    bottom: 0;
    color: #c8c8c8;
    display: flex;
    // position: relative;
    font-size: 26px;
    align-items: center;
    background-color: #f3f3f3;
    &:after{
      top: 0;
      left: 0;
      width: 200%;
      height: 1px;
      display: block;
      content: "";
      position: absolute;
      transform: scale(0.5);
      background-color: #cacaca;
      transform-origin: left top;
    }
    .tab-item{
      flex: 1;
      height: 100px;
      display: flex;
      box-sizing: border-box;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      background-color: transparent;
    }
  }

  .ignore{
    width: 20px;
    height: 20px;
    margin-bottom: 3px;
    background-size: 200%;
    background-image: url("/static/images/home.png");
    background-repeat: no-repeat;
    &.icon-home{
      background-position: 0px -20px;
    }
    &.icon-hall{
      background-position: 0px -80px;
    }
    &.icon-result{
      background-position: 0px -40px;
    }
    &.icon-rule{
      background-position: 0px -20px;
    }
  }
  .router-link-active{
    color: #df2621;
    >.ignore{
      background-position-x: -20PX!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/nav-bar/index.vue